import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AgileIntegrationService } from '../agile/agile-integration.service';

@Injectable({
  providedIn: 'root'
})
export class ShowcaseService {
  public scrollObs$: BehaviorSubject<any> = new BehaviorSubject('');
  public categoryObs$: BehaviorSubject<any> = new BehaviorSubject('');
  public ShowcaseTicketAndSubscriptionListObs$ :BehaviorSubject<any> = new BehaviorSubject([]);

  constructor(private http: HttpClient,private agileIntegration: AgileIntegrationService) { }


  getShowcases(): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/showcases`;
    return this.http.get(url);
  }

  getShowcaseList(): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/showcaseMoviesList`
    return this.http.get(url);
  }

  getFeatureMovieList(): Observable<any> {
    const url = environment.apiURL + `/cinejoy/api/getMoviesList/category/nil/length/Features?parentcatname=Features`;
    return this.http.get(url);
  }
  getShortsMovieList(): Observable<any> {
    const url = environment.apiURL + `/cinejoy/api/getMoviesList/category/nil/length/Shorts?parentcatname=Shorts`;
    return this.http.get(url);
  }

  getMovieById(id): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/getMovieDetails/${id}`;
    return this.http.get(url);
  }

  addComment(id) {
    const url = environment.apiURL + `api/cinejoy/fetchAllCommentsWithReplyCounts/'${id}`;
    return this.http.get(url);
  }

  saveComment(data: any, id) {
    const url = environment.apiURL + `api/cinejoy/fetchAllCommentsWithReplyCounts/${id}`;
    return this.http.post(url, data).subscribe((result) => {
      console.log(result);
    });
  }

  getMoviesByCategories(data, category, subCat): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/getMoviesList/category/${subCat}/length/${category}?parentcatname=${data}`;
    return this.http.get(url)
  }

  getShowcaseArchiveListOnCategory(category, type, genre, year: any = null): Observable<any> {
    let url = environment.apiURL + `api/cinejoy/getArchivedMoviesList/category/${genre}/length/${type}?parentcatname=${category}`;
    if (year != null) {
      url = url + `&cinejoy_year=${year}`
    }
    return this.http.get(url)
  }

  getMovieStream(eventId,eventType:string): Observable<any> {
    const url = environment.apiURL + `api/v2/agiletix/customer/get/streaming/${eventId}`;
    return this.http.get(url, {params:{eventType:eventType}});
  }

  postRating(movieId, rating): Observable<any> {
    let obj = {
      value: rating
    }

    const url = environment.apiURL + `api/cinejoy/rate/${movieId}?value=${rating}`;
    return this.http.post(url, null);
  }

  getCinejoyAdminShowcasesList(): Observable<any> {
    const country = localStorage.getItem('userCountry')
    const headers = new HttpHeaders().set('countryCode', country);
    const url = environment.apiURL + `api/cinejoy-admin/showcase/getCategorizedEvents`;
    return this.http.get(url, { headers });
  }

  getCinejoyAdminShowcaseMoviesByCategories(category: string, subCat: string, showcaseType: string): Observable<any> {
    const country = localStorage.getItem('userCountry')
    const headers = new HttpHeaders().set('countryCode', country);
    const url = environment.apiURL + `api/cinejoy-admin/showcase/getFilteredEvents/${category}/${subCat}/${showcaseType}`;
    return this.http.get(url, { headers });
  }

  getArchivedShowcaseList(category: string, subCat: string, showcaseType: string): Observable<any> {
    const url = environment.apiURL + `api/cinejoy-admin/getArchivedShowcaseList/getFilteredEvents/${category}/${subCat}/${showcaseType}`;
    return this.http.get(url);
  }

  ShowcaseGetEventById(id) : Observable<any>{
    const url = environment.apiURL+`api/cinejoy-admin/showcase/getEvent`;
    let queryParams = new HttpParams().append("eventId",`${id}`);
    return this.http.get(url,{params:queryParams});
  }
  fetchTickets(): void {
    this.agileIntegration.fetchTickets().subscribe({
      next:(response) => {
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];
         let showcaseTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('showcase') ||
            ticket.type.toLowerCase().includes('subscription')

        );
        this.ShowcaseTicketAndSubscriptionListObs$.next(showcaseTickets);
      },
      error:(err)=>{
        console.log(err);
      }
    });
  }
}
